import { atom } from 'recoil';

export const LANGUAGE_KEY = 'languageState';

const loadPref = (key: string): string | null => {
  try {
    const stored = localStorage.getItem(key);
    if (stored) {
      return stored;
    }
  } catch (e) {
  }
  return null;
};

export const languageState = atom<string | null>({
  key: 'languageState',
  default: loadPref(LANGUAGE_KEY),
  effects: [
    ({ onSet }) => {
      onSet(newValue => {
        try {
          localStorage.setItem(LANGUAGE_KEY, newValue as string);
        } catch (e) {
        }
      });
    },
  ],
});